import { useSignal } from "@preact/signals";

interface ErrorDisplayProps {
  error?: string;
}

export default function ErrorDisplay({ error }: ErrorDisplayProps) {

  // Initialize signal directly with the prop value.
  // The signal should automatically update if the 'error' prop changes between renders.
  const errorMessage = useSignal<string | null>(error || null);

  // Render based directly on the signal's value
  if (!errorMessage.value) {
    return null;
  }

  console.log("[ErrorDisplay] Displaying error:", errorMessage.value);
  return (
    <div class="bg-red-500/10 backdrop-blur-md border border-red-500/20 text-red-400 px-6 py-4 rounded-3xl mb-6 flex items-center gap-3 animate-in fade-in slide-in-from-top-4 duration-300">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
      </svg>
      <span class="text-sm font-medium">{errorMessage.value}</span>
    </div>
  );
}
